<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'ProjectsHeader',
  inject: ['wp']
}
</script>
